import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        Kredyt hipoteczny to najczęściej największe finansowe zobowiązanie w życiu — 25 lub
        30 lat ratalnej spłaty wartej często więcej niż całe miesięczne zarobki kilku rodzin.
        Bank pokaże Ci promocyjną ofertę i broszurę z gładkim językiem. Konsekwencje błędów
        w decyzji ponosisz <strong>Ty</strong> — przez kolejne dekady. Te 7 błędów to
        najczęstsze pułapki polskich kredytobiorców. Każdy z nich kosztuje od kilku do
        kilkudziesięciu tysięcy złotych.
      </p>

      <div className="mt-6 p-4 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200">
        <p className="text-sm font-semibold text-foreground mb-2">W pigułce</p>
        <p className="text-sm">
          Łączny koszt 7 błędów na typowym kredycie 500 000 zł może przekroczyć
          <strong> 200 000 zł</strong> w skali całej spłaty. Każdy z nich jest do uniknięcia
          — wystarczy wiedzieć, na co zwrócić uwagę PRZED podpisaniem umowy.
        </p>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Błąd 1: Wzięcie maksymalnego kredytu, na jaki bank Cię stać</h2>
      <p>
        Bank policzy Twoją zdolność kredytową i przedstawi maksymalną kwotę kredytu. Klient
        często słyszy „stać Cię na ratę 4 500 zł" i myśli — „skoro mogę, to wezmę". Problem
        polega na tym, że bank uwzględnia <strong>aktualne</strong> warunki: stałą pracę, brak
        zachorowań, brak dzieci, brak rozwodu. Życie rzadko trzyma się tych założeń przez
        25 lat.
      </p>
      <p className="mt-3">
        <strong>Ile to kosztuje:</strong> jedna utrata pracy lub poważna choroba przy racie
        powyżej 35% dochodu netto prowadzi do zaległości, sankcji banku i potencjalnie wpisu
        do BIK. Koszt? Lata problemów z każdym kolejnym kredytem, w skrajnych przypadkach
        utrata mieszkania w drodze egzekucji komorniczej.
      </p>
      <p className="mt-3">
        <strong>Co zrobić zamiast tego:</strong> trzymaj ratę poniżej 35% dochodu netto (Rekomendacja
        S KNF traktuje tę granicę jako bezpieczną), a najlepiej w okolicach 25-30%. Sprawdź,
        ile naprawdę potrzebujesz zarabiać w naszym artykule
        o <BlogLink slug="ile-zarabiac-na-kredyt-hipoteczny">zarobkach a kredycie hipotecznym</BlogLink>.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Błąd 2: Niesprawdzenie różnicy między ratami równymi i malejącymi</h2>
      <p>
        Banki domyślnie oferują raty równe (annuitetowe) — są wygodniejsze do sprzedaży, bo
        rata wygląda stabilnie. Większość kredytobiorców nawet nie wie, że istnieje alternatywa,
        a doradca rzadko sam ją proponuje. Tymczasem różnica w łącznym koszcie kredytu jest
        ogromna.
      </p>
      <p className="mt-3">
        <strong>Ile to kosztuje:</strong> dla kredytu 400 000 zł na 25 lat przy oprocentowaniu
        7,85% — raty równe dają sumę odsetek około 514 000 zł, raty malejące około 394 000 zł.
        Różnica to <strong>120 000 zł</strong> mniej zapłaconych odsetek — jeśli wybierzesz raty
        malejące zamiast równych.
      </p>
      <p className="mt-3">
        <strong>Co zrobić zamiast tego:</strong> poproś bank o symulację OBU wariantów i porównaj
        łączny koszt kredytu, nie tylko miesięczną ratę. Przeczytaj porównanie
        w artykule <BlogLink slug="raty-rowne-czy-malejace">o ratach równych vs malejących</BlogLink>.
      </p>
      <div className="mt-4">
        <CalculatorLink installmentType="decreasing">
          Porównaj oba typy rat w kalkulatorze
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Błąd 3: Porównywanie ofert po oprocentowaniu zamiast po RRSO</h2>
      <p>
        Bank reklamuje „oprocentowanie od 6,5%". Inny bank — „od 6,2%". Wygląda na to, że
        drugi jest tańszy. W rzeczywistości pierwszy ma RRSO 7,1%, a drugi 7,8% — bo zawiera
        wyższą prowizję, droższe ubezpieczenia i ukryte opłaty.
      </p>
      <p className="mt-3">
        <strong>Ile to kosztuje:</strong> kredyt z niższym oprocentowaniem ale wyższym RRSO może
        być droższy łącznie nawet o 30 000-50 000 zł w skali 25 lat. Banki to wiedzą i celowo
        eksponują niższe oprocentowanie w marketingu.
      </p>
      <p className="mt-3">
        <strong>Co zrobić zamiast tego:</strong> RRSO (Rzeczywista Roczna Stopa Oprocentowania) to
        jedyna liczba, która zawiera wszystkie koszty kredytu — banki muszą ją podawać zgodnie
        z <strong>ustawą o kredycie hipotecznym z 23 marca 2017 roku</strong>. Porównuj oferty
        wyłącznie po RRSO. Szczegóły w artykule <BlogLink slug="rrso-kredyt-hipoteczny">o RRSO</BlogLink>.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Błąd 4: Niedoliczenie kosztów transakcyjnych zakupu nieruchomości</h2>
      <p>
        Klient zbiera 100 000 zł na wkład własny do mieszkania za 500 000 zł i myśli, że jest
        gotowy. Po wizycie u notariusza okazuje się, że oprócz wkładu potrzeba jeszcze prowizji
        banku, podatku PCC, taksy notarialnej, opłat sądowych, wyceny nieruchomości i
        ubezpieczeń. Te koszty są rozproszone, więc łatwo je zignorować w planowaniu.
      </p>
      <p className="mt-3">
        <strong>Ile to kosztuje:</strong> dodatkowe 3-5% wartości nieruchomości — czyli dla
        mieszkania za 500 000 zł to <strong>15 000-25 000 zł</strong> ponad wkład własny.
        PCC (2% przy rynku wtórnym, zgodnie z ustawą Ministerstwa Finansów) sam może wynieść
        10 000 zł.
      </p>
      <p className="mt-3">
        <strong>Co zrobić zamiast tego:</strong> dodaj 5% wartości nieruchomości do budżetu
        zakupowego ponad wymagany wkład własny. Pełną listę kosztów znajdziesz w artykule
        o <BlogLink slug="wklad-wlasny-kredyt-hipoteczny">wkładzie własnym</BlogLink>.
      </p>
      <div className="mt-4">
        <CalculatorLink section="extra-costs">
          Oblicz dodatkowe koszty kredytu w kalkulatorze
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Błąd 5: Branie kredytu w jednym banku bez porównania ofert</h2>
      <p>
        Klient idzie do swojego banku, w którym ma rachunek od 10 lat, i bierze pierwszą
        proponowaną ofertę. „Mam ROR, mam kartę kredytową, lubię swojego doradcę" — to typowe
        argumenty. Bank to wykorzystuje, bo wie, że nie sprawdzisz konkurencji.
      </p>
      <p className="mt-3">
        <strong>Ile to kosztuje:</strong> różnica marży 0,3 punktu procentowego między bankami
        to <strong>około 30 000 zł</strong> w skali 25-letniego kredytu 400 000 zł. Różnica
        prowizji 1 punkt procentowy = kolejne 4 000 zł. Razem łatwo dochodzimy do 30-50 000 zł
        oszczędności po prostu z porównania ofert.
      </p>
      <p className="mt-3">
        <strong>Co zrobić zamiast tego:</strong> złóż wnioski w 3-4 bankach jednocześnie (każda
        oferta jest ważna 21 dni od decyzji kredytowej zgodnie z ustawą). Następnie negocjuj
        w docelowym banku, pokazując konkurencyjne oferty. UOKiK potwierdza, że taka strategia
        jest legalna i banki regularnie obniżają marżę przy konkurencyjnych propozycjach.
        Jeśli już masz kredyt, sprawdź <BlogLink slug="refinansowanie-kredytu-hipotecznego">opcję
        refinansowania</BlogLink>.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Błąd 6: Brak poduszki finansowej przed wzięciem kredytu</h2>
      <p>
        Kupujący wydają WSZYSTKIE oszczędności na wkład własny i koszty transakcyjne. Po
        podpisaniu umowy zostają z saldem zerowym, bez bufora na nieprzewidziane wydatki.
        Pierwsze nieoczekiwane wydarzenie — awaria samochodu, nagła operacja, utrata pracy —
        wpędza ich w spiralę problemów.
      </p>
      <p className="mt-3">
        <strong>Ile to kosztuje:</strong> jedno opóźnienie raty kredytu hipotecznego = wpis do
        BIK, który psuje Twoją historię kredytową na 5 lat. Według danych Biura Informacji
        Kredytowej średni koszt jednego negatywnego wpisu to znacznie gorsze warunki przy
        kolejnych kredytach przez wiele lat — wyższa marża, wyższa prowizja, większe wymogi.
      </p>
      <p className="mt-3">
        <strong>Co zrobić zamiast tego:</strong> ZACHOWAJ 3-6 miesięcy podstawowych wydatków
        rodziny na koncie oszczędnościowym oprócz wkładu własnego. Lepiej kupić mieszkanie
        rok później z bezpieczną poduszką niż dziś z saldem zerowym. Jeśli masz nadwyżkę po
        kredycie, możesz ją wykorzystać na <BlogLink slug="nadplata-kredytu-hipotecznego">nadpłatę kredytu</BlogLink> — ale dopiero
        gdy poduszka jest pełna.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Błąd 7: Niesprawdzanie zapisów o nadpłacie i wcześniejszej spłacie</h2>
      <p>
        W umowie kredytowej znajduje się klauzula o opłatach za wcześniejszą spłatę. Bank
        może pobierać prowizję od nadpłaty w pierwszych 3 latach kredytu — najczęściej
        1-3% kwoty nadpłaty. Ten zapis jest wpisany drobnym drukiem, a klient zwykle go nie
        zauważa.
      </p>
      <p className="mt-3">
        <strong>Ile to kosztuje:</strong> nadpłata 50 000 zł w drugim roku kredytu = nawet
        <strong> 1 500 zł prowizji</strong>. Jeśli planujesz regularnie nadpłacać, te opłaty
        kumulują się znacznie. Niektórzy klienci tracą motywację do nadpłat, gdy odkryją
        prowizję — i tracą dziesiątki tysięcy złotych oszczędności na odsetkach.
      </p>
      <p className="mt-3">
        <strong>Co zrobić zamiast tego:</strong> PRZECZYTAJ klauzule o nadpłacie PRZED podpisaniem
        umowy. Zgodnie z <strong>ustawą o kredycie hipotecznym z 2017 roku</strong> bank może
        pobierać opłatę za wcześniejszą spłatę przez maksymalnie 3 lata od podpisania umowy
        i nie wyższą niż 3% nadpłacanej kwoty. Po tym okresie nadpłaty są zawsze bezpłatne.
        Wybierz bank z najniższymi opłatami za nadpłatę.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Podsumowanie — ile zaoszczędzisz unikając tych 7 błędów?</h2>
      <p>
        Konkretne liczby dla typowego kredytu 500 000 zł na 25 lat:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>Błąd 1 (zbyt wysoka rata): wartość poduszki finansowej, której nie masz — <strong>20 000-50 000 zł</strong> ryzyka</li>
        <li>Błąd 2 (raty równe zamiast malejących): <strong>~120 000 zł</strong> więcej odsetek</li>
        <li>Błąd 3 (oprocentowanie zamiast RRSO): <strong>~30 000-50 000 zł</strong></li>
        <li>Błąd 4 (pominięte koszty transakcyjne): <strong>~15 000-25 000 zł</strong> niespodziewanych wydatków</li>
        <li>Błąd 5 (brak porównania banków): <strong>~30 000-50 000 zł</strong></li>
        <li>Błąd 6 (brak poduszki): trudna do wyceny, ale potencjalnie <strong>utrata mieszkania</strong></li>
        <li>Błąd 7 (prowizja od nadpłaty): <strong>~3 000-10 000 zł</strong> w pierwszych 3 latach</li>
      </ul>
      <p className="mt-4">
        Łącznie: <strong>ponad 200 000 zł oszczędności i bezpieczeństwa</strong> — za jedną-dwie
        godziny porównania ofert i przeczytania umowy z uwagą. Najlepsza godzina pracy w Twoim
        życiu.
      </p>

      <div className="mt-6">
        <CalculatorLink>
          Sprawdź swoją sytuację w kalkulatorze RatyGo
        </CalculatorLink>
      </div>

      <p className="text-xs text-muted-foreground mt-8 pt-4 border-t border-border/50">
        <span className="font-semibold">Źródła:</span> ustawa o kredycie hipotecznym z 23 marca 2017 r. · KNF (Rekomendacja S) · Ministerstwo Finansów (ustawa o PCC) · UOKiK · BIK
      </p>
    </>
  )
}
